import { useApolloClient } from "@apollo/client";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { StatusType } from "__generated__/enums";
import { GetStatusesDocument, GetStatusesQuery } from "__generated__/view/statuses/graphql/queries.generated";
import { ChildPropsFromPagination } from "types/commons";

export type StatusPaginatedSelectOption = ChildPropsFromPagination<GetStatusesQuery, "statuses">;

const StatusPaginatedSelect = <Multiple extends boolean = false,>({
	statusId,
	value,
	onChange,
	type,
	multiple,
	includeActionStatus,
}: Pick<SelectProps<StatusPaginatedSelectOption, Multiple>, "value" | "onChange" | "multiple" | "getOptionDisabled"> & { statusId?: number; type?: StatusType; includeActionStatus?: boolean; }) => {

	const client = useApolloClient();

	const onFetchOptionsPaginated = async(params: string, page: number) => {
		try {
			const result = await client.query({
				query: GetStatusesDocument,
				variables: {
					pagination: {
						page: page - 1,
						size: 5,
					},
					search: {
						ids: statusId ? [ statusId ] : undefined,
						types: type ? [ type ] : undefined,
						description: params,
						includeActionStatus: includeActionStatus,
					},
				},
			});

			return {
				options: result.data.statuses.content,
				totalResults: result.data.statuses.totalElements || 0,
			};

		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			fetchOptions={onFetchOptionsPaginated}
			paginated
			multiple={multiple}
			getOptionLabel={option => option.description || ""}
			onChange={onChange}
			value={value}
		/>
	);
};

export default StatusPaginatedSelect;
